import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyTimeRequestTypeInterfaceProps {
  data?: any;
  myTimeType: string;
  timeDataTypeName: string;
  unPaidDate: boolean;
}

export const MyTimeRequestTypeInterface = ({
  data = [],
  myTimeType,
  timeDataTypeName,
  unPaidDate
}: MyTimeRequestTypeInterfaceProps) => {
  const theme = useTheme();

  const { t } = useTranslation();

  let displayDayType = myTimeType;
  let displayTimeDataTypeName = timeDataTypeName;
  let displayMyTimeType = myTimeType;

  if (data?.length !== 0) {
    if (data?.myTimeType) {
      displayDayType = data?.myTimeType;
    }
    displayTimeDataTypeName = data?.timeDataTypeName;
    displayMyTimeType = t("MY_TIME_TYPE");
  }

  return (
    <Box
      style={{
        borderRadius: "8px",
        backgroundColor: theme.palette.gray30.main,
        padding: "16px",
      }}
    >
      <Typography variant="body1">{t("OC_TYPE")}:</Typography>
      <Typography variant="body1" style={{ color: theme.palette.primary.main }}>
        {unPaidDate ? t(`MY_TIME_${data?.dayType}`) : t(`MY_TIME_${displayDayType}`)}
      </Typography>
      <Box height="6px" />
      <Typography variant="body1">{t(displayMyTimeType)}:</Typography>
      <Typography variant="body1" style={{ color: theme.palette.primary.main }}>
        {unPaidDate ? "-" : displayTimeDataTypeName}
      </Typography>
    </Box>
  );
};

export default MyTimeRequestTypeInterface;
